var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-card"},[(_vm.isLoading)?_c('loading'):(!_vm.form.type)?_c('choose-battery-type',{on:{"set:batteryType":_vm.SET_BATTERY_TYPE}}):(!_vm.hasAuthorize())?_c('not-auth'):_c('div',[_c('battery-features',{attrs:{"form":_vm.form},on:{"created":_vm.CREATED_BATTERY}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }